import { Component, OnInit } from '@angular/core';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { ModalSize, SmartModalService } from '../../services/smart-modal.service';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { BaseService } from '../../shared/services/base.service';
import { DialogRef } from '../dialog/dialog-ref';
import _moment from 'proxies/dayjs';
import { TncComponent } from '../tnc/tnc.component';

@Component({
    selector: 'app-consent-check',
    templateUrl: './consent-check.component.html',
    styleUrls: ['./consent-check.component.scss'],
    standalone: false
})
export class ConsentCheckComponent implements OnInit {
  patientData: any ={};
  consentCheck: boolean = false;
  disabledButton: boolean = false;
  consentTime: string;

  constructor(
    private modalService: SmartModalService,
    private baseService: BaseService,
    private authenticationService: AuthenticationService,
    private alertService: AlertsService,
    public dialog: DialogRef,
    private spinner: LoaderService,
  ) { }

  ngOnInit(): void {
    this.getPatientDetails();
  }

  getPatientDetails(){
    let args = "id:"+this.authenticationService.getCurrentUser()['user_id']
    this.baseService.get("GET_BY_ID", args, "patient", "patient-registration").subscribe(
      (res) => {
        if(res.errCode == 0 && res.resource && res.resource.length != 0){
          this.patientData = res.resource[0]
          if(this.patientData.is_consent){
            this.consentCheck = this.patientData.is_consent
            this.consentTime = _moment(+this.patientData.consent_time).format('DD/MM/YYYY hh:mm a')
            this.disabledButton = true;
          }
        }
    })
  }

  updateConsent(){
    if(!this.consentCheck){
        this.alertService.error("Please accept Terms of Service")
        return;
    }
    this.spinner.showSpinner()
    let resource = this.patientData && this.patientData.registrationType == "pre-registration" ? 'pre_registration':'patient'
    this.patientData.is_consent = this.consentCheck
    this.baseService.action(this.patientData, 'MODIFY', 'patient-registration', resource).subscribe((result) => {
      if (result.errCode == 0) {
        this.alertService.success(result.message);
        this.dialog.close();
      }
      else
        this.alertService.error(result.message)
      this.spinner.hideSpinner()
    })

  }

  showTnc() {
    this.modalService.open(TncComponent, '', 'Terms of Service and Data Privacy Notice', ModalSize.Lg, 'center', true).subscribe(res => {
      if (res) {
        console.log('tnc modal closed');
      }
    }, err => {
      console.error('error occured in tnc modal', err);
    })
  }
}
